const heading4 = [
  "M3.29 11.54V8.62h3.17v2.92H7.8V4.46H6.46v2.9H3.29v-2.9H1.95v7.08zm10.13 0v-1.1h.63V9.19h-.63V7.42h-1.36V9.2h-1.54l2.23-4.73h-1.53L8.98 9.19v1.25h3.08v1.1z"
];
export {
  heading4
};
//# sourceMappingURL=heading4.js.map
